"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constructFullPageUrl = constructFullPageUrl;
exports.constructFullPageUrlFromSegments = constructFullPageUrlFromSegments;
exports.createCommaSeparatedList = createCommaSeparatedList;
exports.createFullPageSlug = createFullPageSlug;
exports.createPageSlug = createPageSlug;
exports.createPageTitle = createPageTitle;
exports.domainToUrl = domainToUrl;
exports.ensureSlugSlashes = ensureSlugSlashes;
exports.getPageByType = getPageByType;
exports.getPageUrl = getPageUrl;
exports.getPages = getPages;
exports.getQuery = getQuery;
exports.getQueryIterator = getQueryIterator;
exports.getTemplatePath = getTemplatePath;
exports.joinPathSegmentsIntoUrl = joinPathSegmentsIntoUrl;
exports.removeSlugSlashes = removeSlugSlashes;
exports.slugify = slugify;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _lodash = _interopRequireDefault(require("lodash"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _constants = require("./constants");
var _queries = require("./queries");
var _page = require("./queries/page");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function slugify(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!(0, _isString2["default"])(value)) {
    throw new Error('The provided value must be a string.');
  }
  var _options$replaceSlash = options.replaceSlashes,
    replaceSlashes = _options$replaceSlash === void 0 ? false : _options$replaceSlash;
  return _lodash["default"].chain(value).toLower().trim().replace(/[^a-z0-9-/\s]/g, '').replace(replaceSlashes ? /[/\s]+/g : /\s+/g, '-').replace(/^-+/, '').replace(/-+$/, '').replace(/-+/, '-').value();
}
function removeSlugSlashes(slug) {
  if (!slug) {
    return '';
  }
  return slug.replace(/^\/+|\/+$/g, '');
}
function ensureSlugSlashes(slug) {
  if (!slug) {
    return '';
  }
  return '/'.concat(removeSlugSlashes(slugify(slug))).concat('/');
}
function createFullPageSlug(rootSlug, pageSlug) {
  var cleanedRootSlug = removeSlugSlashes(slugify(rootSlug));
  var cleanedPageSlug = removeSlugSlashes(slugify(pageSlug));
  return ensureSlugSlashes([cleanedRootSlug, cleanedPageSlug].join('/'));
}
function createPageSlug(queryName, pageQueryResult, pageQueryResults) {
  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var slugFieldLookup = _queries.QUERY_SLUG_LOOKUPS[queryName];
  var finalContext = _objectSpread(_objectSpread({}, context), {}, {
    slugify: slugify
  });
  if ((0, _isFunction2["default"])(slugFieldLookup)) {
    return slugify(slugFieldLookup(pageQueryResult, pageQueryResults, finalContext));
  }
  return slugify((0, _get2["default"])(pageQueryResult, slugFieldLookup), {
    replaceSlashes: true
  });
}
function createPageTitle(queryName, pageQueryResult, pageQueryResults) {
  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var titleFieldLookup = _queries.QUERY_TITLE_LOOKUPS[queryName];
  if ((0, _isNil2["default"])(titleFieldLookup)) {
    return null;
  }
  if ((0, _isFunction2["default"])(titleFieldLookup)) {
    return titleFieldLookup(pageQueryResult, pageQueryResults, context);
  }
  return (0, _get2["default"])(pageQueryResult, titleFieldLookup);
}
function getTemplatePath(recipe, templateName) {
  return "./templates/".concat(recipe, "/").concat((0, _get2["default"])(_constants.TEMPLATE_NAMES, "".concat(recipe, ".").concat(templateName)), ".jsx");
}
function getQuery(queryName) {
  return _queries.QUERIES[queryName];
}
function getQueryIterator(queryName, queryResult) {
  var queryIteratorPath = _queries.QUERY_ITERATOR_PATHS[queryName];
  return (0, _get2["default"])(queryResult, queryIteratorPath);
}
function getPages(_x) {
  return _getPages.apply(this, arguments);
}
function _getPages() {
  _getPages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(graphql) {
    var _yield$graphql, data;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return graphql(_page.query);
        case 2:
          _yield$graphql = _context.sent;
          data = _yield$graphql.data;
          return _context.abrupt("return", (0, _get2["default"])(data, ['allFishermanBusinessWebsitePage', 'nodes'], []));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getPages.apply(this, arguments);
}
function getPageByType(_x2, _x3) {
  return _getPageByType.apply(this, arguments);
}
function _getPageByType() {
  _getPageByType = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(graphql, pageType) {
    var pages;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (pageType) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", null);
        case 2:
          _context2.next = 4;
          return getPages(graphql);
        case 4:
          pages = _context2.sent;
          return _context2.abrupt("return", pages.find(function (_ref3) {
            var currentPageType = _ref3.pageType;
            return currentPageType === pageType;
          }));
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getPageByType.apply(this, arguments);
}
function constructFullPageUrl(baseUrl, pagePath) {
  return "".concat(baseUrl).concat(ensureSlugSlashes(pagePath));
}
function joinPathSegmentsIntoUrl() {
  for (var _len = arguments.length, segments = new Array(_len), _key = 0; _key < _len; _key++) {
    segments[_key] = arguments[_key];
  }
  if ((0, _isEmpty2["default"])(segments)) {
    return '';
  }
  var url = segments.map(function (segment) {
    return removeSlugSlashes(slugify(segment));
  }).join('/');
  url = url.endsWith('/') ? url : "".concat(url, "/");
  url = url.startsWith('/') ? url : "/".concat(url);
  return url;
}
function constructFullPageUrlFromSegments(baseUrl) {
  for (var _len2 = arguments.length, segments = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    segments[_key2 - 1] = arguments[_key2];
  }
  return "".concat(baseUrl).concat(joinPathSegmentsIntoUrl.apply(void 0, segments));
}
function createCommaSeparatedList(list) {
  return list.reduce(function (acc, element, index, array) {
    if (array.length === 1) {
      return acc.concat(element);
    }
    if (index === array.length - 1) {
      var andSeparator = array.length === 2 ? " and " : ", and ";
      return acc.concat(andSeparator, element);
    }
    if (!(index === array.length - 2)) {
      return acc.concat(element, ", ");
    }
    return acc.concat(element);
  }, []);
}
function domainToUrl(domain) {
  if (!domain) {
    return '';
  }
  if (domain.startsWith('http')) {
    return "".concat(domain);
  }
  return "https://".concat(domain);
}
function getPageUrl(website) {
  var slugParts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _ref = website || {},
    _ref$domains = _ref.domains,
    domains = _ref$domains === void 0 ? [] : _ref$domains;
  var domain = domains.find(function (_ref2) {
    var primaryDomain = _ref2.primaryDomain;
    return primaryDomain;
  });
  if ((0, _isEmpty2["default"])(domain)) {
    return '';
  }
  var siteUrl = domain.url;
  siteUrl = domainToUrl(siteUrl);
  siteUrl = siteUrl.endsWith('/') ? siteUrl.slice(0, -1) : siteUrl;
  var slugUrl = slugParts.join('/');
  slugUrl = slugUrl.startsWith('/') ? slugUrl.slice(1) : slugUrl;
  return "".concat(siteUrl, "/").concat(slugUrl);
}